export const WEB_PUSH_ACTION = {
  GRANTED: "granted",
  BLOCKED: "denied",
  DEFAULT: "default",
  SHOW: "show",
} as const;

export const webPushAction = {
  [WEB_PUSH_ACTION.GRANTED]: 1,
  [WEB_PUSH_ACTION.BLOCKED]: 2,
  [WEB_PUSH_ACTION.DEFAULT]: 3,
  [WEB_PUSH_ACTION.SHOW]: 4,
};

export const WEB_PUSH_TYPE = {
  LIKE: "like",
  MESSAGE: "message",
  FAVORITE: "favorite",
  INACTIVE: "inactive",
} as const;
